import { Component, OnInit } from '@angular/core';
import { ProductsService } from '../../services/products.service';
import { ToasterService } from 'angular2-toaster';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.scss']
})
export class AddProductComponent implements OnInit {
  
  apiUrl: string = environment.apiUrl;
  
  newProduct: any = {
    // id: '',
    application: 'Home',
    description: '',
    left_menu_alias: '',
    height: 1.27,
    length: 203.2,
    width: 101.6,
    defaultHeightFromFloor: 0,
    maxSpacing: {},
    modelMtl: '',
    modelObj: '',
    productGroup: 'Generic',
    productImg: '',
    productImg1: '',
    productType: 'Accessory',
    isGeneric: false,
    textures: [],
    railingType: [],
    mountType: '',
    heightGroup: '',
    cornerType: '',
    angleType: '',
    placementRule: '',
    postCap: ''
  };

  productTypes = [
    'Accessory',
    'Intermediate Post',
    'Intermediate Angled Post', 
    'Corner Post',
    'Handrail',
    'Baserail',
    'Horizontal Cable',
    'Vertical Cable',
    'Infill',
    'Vertical Picket',
    'Post Cap',
    'Door',
    'Window',
    'Awning',
    'Trellis',
    'Stair Handrail'
  ];

  constructor(
    private productsService: ProductsService,
    private toasterService: ToasterService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    // Generate unique ID
    // this.newProduct.id = this.generateUniqueId();
    // this.newProduct.id = '64D89642be2T9c7f6f52de6d';
    
    // Initialize textures array
    if (!this.newProduct.textures) {
      this.newProduct.textures = [];
    }
    
    // Checking authorization
    if (!this.authService.isAuthenticated()) {
      this.toasterService.popAsync('warning', 'Authentication Required', 'Please log in to add products.');
    }
  }

  generateUniqueId(): string {
    return 'product_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  addProduct() {
    if (!this.validateProduct()) {
      return;
    }

    this.productsService.addProduct(this.newProduct).subscribe(
      (response) => {
        this.toasterService.popAsync('success', 'Success', 'Product added successfully!');
        this.resetForm();
        console.log('Product added:', response);
      },
      (error) => {
        this.toasterService.popAsync('error', 'Error', 'Failed to add product: ' + error.message);
        console.error('Error adding product:', error);
      }
    );
  }

  validateProduct(): boolean {
    if (!this.newProduct.description) {
      this.toasterService.popAsync('warning', 'Validation Error', 'Description is required');
      return false;
    }
    if (!this.newProduct.productType) {
      this.toasterService.popAsync('warning', 'Validation Error', 'Product type is required');
      return false;
    }
    if (!this.newProduct.productImg) {
      this.toasterService.popAsync('warning', 'Validation Error', 'Product image is required');
      return false;
    }
    return true;
  }

  resetForm() {
    this.newProduct = {
      id: this.generateUniqueId(),
      application: 'Home',
      description: '',
      left_menu_alias: '',
      height: 1.27,
      length: 203.2,
      width: 101.6,
      defaultHeightFromFloor: 0,
      maxSpacing: {},
      modelMtl: '',
      modelObj: '',
      productGroup: 'Generic',
      productImg: '',
      productImg1: '',
      productType: 'Accessory',
      isGeneric: false,
      textures: [],
      railingType: '',
      mountType: '',
      heightGroup: '',
      cornerType: '',
      angleType: '',
      placementRule: '',
      postCap: ''
    };
  }

  addTexture() {
    if (!this.newProduct.textures) {
      this.newProduct.textures = [];
    }
    this.newProduct.textures.push('');
  }

  removeTexture(index: number) {
    this.newProduct.textures.splice(index, 1);
  }

  updateTexture(index: number, value: string) {
    if (!this.newProduct.textures) {
      this.newProduct.textures = [];
    }
    this.newProduct.textures[index] = value;
  }

  onTextureInput(index: number, event: any) {
    const value = event.target.value;
    if (!this.newProduct.textures) {
      this.newProduct.textures = [];
    }
    this.newProduct.textures[index] = value;
    // Force change detection by creating a new array reference
    this.newProduct.textures = [...this.newProduct.textures];
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }
} 


// WEBPACK FOOTER //
// ./src/app/admin/add-product/add-product.component.ts